import { jsx as _jsx } from "react/jsx-runtime";
import { useCallback } from 'react';
import { BroadcastService } from '../services/broadcast/BroadcastService';
import { MediaService } from '../services/media/MediaService';
export function BroadcasterCanvas() {
    const mirror = MediaService.getOutput().useMediaStreamData().isUserFacingVideo;
    const setCanvas = useCallback((canvas) => {
        if (!canvas) {
            return;
        }
        BroadcastService.getNotificationInterface().notifyCanvasMounted(canvas);
    }, []);
    return (_jsx("canvas", { ref: setCanvas, style: {
            transform: mirror ? 'scaleX(-1)' : undefined,
        } }));
}
